import {
  Button,
  CloudImage,
  Container,
  Heading,
  Text,
} from "@fluidattacks/design";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { openUrl } from "utils/resource-helpers";

const CALENDAR_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0ZSgVbAJh3yuV0KUzBLjrZbKxVHhflbXO6a-vPRXtgmbhKphQHUCGPK4lLeKMb48zJl0HSwu7K";

const UpgradeFlow = ({
  handleUpgradeFlow,
}: {
  handleUpgradeFlow: () => void;
}): JSX.Element => {
  const { t } = useTranslation();
  const handleOpenLink = useCallback((): void => {
    openUrl(CALENDAR_URL);
  }, []);

  return (
    <Container
      alignItems={"center"}
      display={"flex"}
      flexDirection={"column"}
      gap={1.25}
      justify={"center"}
      pt={2}
      textAlign={"center"}
      width={"100%"}
    >
      <CloudImage publicId={"integrates/plans/upgrade-flow"} width={80} />
      <Heading size={"lg"}>
        {t("organization.billing.upgradeFlow.heading")}
      </Heading>
      <Text size={"md"}>
        {t("organization.billing.upgradeFlow.description")}
      </Text>
      <Container display={"flex"} gap={0.5}>
        <Button onClick={handleUpgradeFlow} variant={"primary"}>
          {"Upgrade"}
        </Button>
        <Button
          onClick={handleOpenLink}
          rightIcon={"arrow-right"}
          variant={"ghost"}
        >
          {"Contact us"}
        </Button>
      </Container>
    </Container>
  );
};

export { UpgradeFlow };
